import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  AdminForgetPasswordInputDto,
  AdminGenerateUserOTPInputDto,
  AdminLoginInputDto,
  AdminLoginReturnDtoGeneralResponse,
  AdminNewPasswordInputDto,
  AdminOTPInputDto,
  AdminOTPOutputDtoGeneralResponse,
  SetFundManagerPasswordInputDto,
  StringGeneralResponse,
} from '../data-models/authentication.data.models';
import { EUserType, GeneralResponse } from 'src/app/shared/shared-data-models';
import { BaseApiService } from 'src/app/shared/services/base-api.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/AccountDashboard/`;

  constructor(private baseApiService: BaseApiService<any>) {}

  login(
    body: AdminLoginInputDto | undefined
  ): Observable<AdminLoginReturnDtoGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}Login`, body);
  }

  setFundManagerPassword(
    body: SetFundManagerPasswordInputDto | undefined
  ): Observable<GeneralResponse<boolean>> {
    return this.baseApiService.Post(
      `${this.controllerUrl}setFundManagerPassword`,
      body
    );
  }
  forgetPassword(
    body: AdminForgetPasswordInputDto | undefined
  ): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(
      `${this.controllerUrl}ForgetPassword`,
      body
    );
  }
  setNewPassword(
    body: AdminNewPasswordInputDto | undefined
  ): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(
      `${this.controllerUrl}SetNewPassword`,
      body
    );
  }
  logout(): Observable<StringGeneralResponse> {
    return this.baseApiService.Get(`${this.controllerUrl}Logout`);
  }

  generateUserOTP(
    body: AdminGenerateUserOTPInputDto | undefined
  ): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(
      `${this.controllerUrl}GenerateUserOTP`,
      body
    );
  }
  validateUserOTP(
    body: AdminOTPInputDto | undefined
  ): Observable<AdminLoginReturnDtoGeneralResponse> {
    return this.baseApiService.Post(
      `${this.controllerUrl}ValidateUserOTP`,
      body
    );
  }

  getUserOTPDev(
    email: string | undefined,
     userTypeId?: EUserType
  ): Observable<AdminOTPOutputDtoGeneralResponse> {
    return this.baseApiService.Get(
      `${this.controllerUrl}GetUserOTPDev?email=${email}&userTypeId=${userTypeId}`
    );
  }
}
